export default __webpack_public_path__ + "static/bold-neutrals-light-91b18edd3d0eaed7c05cbcf5482dfbcd6732c00ff05540ff8842b2e2c7de673c.png";